import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'quarter', label: 'Period', sortable: true },
    { key: 'file', sortable: true },
    { key: 'actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('orgMonitoring'),
  }
}
